import React from 'react';
import Head from 'next/head';

/**
 * Viewport must be in the _app
 *  - @see https://stackoverflow.com/a/65833534
 * @param req
 * @constructor
 */
const DynamicHeadScripts = () => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Head>
);

export default DynamicHeadScripts;
